export const ru = {
    'link-domain-not-match-main': 'Ссылка не ведет на страницу основного сайта',
    'sitelink-descr-allowed-symbols':
        'Недопустимые символы в описании быстрой ссылки',
    'sitelink-descr-dublicate': 'Описания быстрых ссылок должны быть разными',
    'sitelink-descr-max-length':
        'Превышена допустимая длина описания быстрой ссылки в {maxLength} символов',
    'sitelink-descr-no-empty': 'Укажите описание быстрой ссылки',
    'sitelink-descr-not-allowed-symbols':
        'Недопустимые символы в описании быстрой ссылки',
    'sitelink-href-invalid': 'Адрес сайта не указан или указан неверно',
    'sitelink-href-length':
        'Превышена допустимая длина ссылки в {maxLength} символа',
    'sitelink-title-empty': 'Необходимо указать заголовок быстрой ссылки',
    'sitelink-title-max-length':
        'Превышена допустимая длина заголовка быстрой ссылки в {maxLength} символов',
    'sitelink-title-restricted-chars-in-field':
        'В заголовке быстрой ссылки можно использовать только буквы латинского, турецкого, русского, украинского, казахского или белорусского алфавита, знаки препинания, за исключением символов «!»,«?».',
    'sitelinks-common-title-max-length':
        'Превышена допустимая длина заголовков ссылок в {maxLength} символов',
    'sitelinks-duplicate-errors': 'Заголовки ссылок должны быть разные',
    'sitelinks-first-block-common-title-max-length':
        'Превышена допустимая длина заголовков первых четырех быстрых ссылок в {maxLength} символов',
    'sitelinks-need-to-save':
        'Завершите редактирование быстрых ссылок, прежде чем сохранять объявление',
    'sitelinks-second-block-common-title-max-length':
        'Превышена допустимая длина заголовков дополнительных четырех быстрых ссылок в {maxLength} символов',
    'sitelinks-unknown-error': 'Произошла неизвестная ошибка'
};
